import React from 'react';
import proptypes from 'prop-types';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AddToQuote } from '@thd-olt-component-react/add-to-quote';

const { bool, string, number } = proptypes;

export const BuyboxAddToQuote = ({
  itemId, fulfillmentLocation, fulfillmentMethod, quantity = 1, disabled
}) => {
  return (
    <ErrorBoundary name="buybox-add-to-quote">
      <AddToQuote
        itemId={itemId}
        fulfillmentLocation={fulfillmentLocation}
        fulfillmentMethod={fulfillmentMethod}
        quantity={quantity}
        disabled={disabled}
      />
    </ErrorBoundary>
  );
};

BuyboxAddToQuote.propTypes = {
  itemId: string.isRequired,
  fulfillmentLocation: string.isRequired,
  fulfillmentMethod: string.isRequired,
  quantity: number,
  disabled: bool.isRequired
};
